import { parsePlanningTodoAgentJson } from '@buildautomaton/types';
import type { LogFn } from '../../log.js';
import {
  consumePlanningSessionTurnOutput,
  getPlanningSessionTurnOutput,
} from './planning-session-turn-buffer.js';
import { submitPlanningTodosForTurn } from './submit-planning-todos-for-turn.js';

export type PlanningTodosSubmitResult = {
  /** Todos were parsed and submitted successfully. */
  submitted: boolean;
  /** Omit agent `output` from prompt_result (JSON already stored as planning_todos block). */
  suppressOutput: boolean;
};

export async function maybeSubmitPlanningTodosAfterAgentSuccess(params: {
  sessionId: string | undefined;
  runId: string | undefined;
  resultSuccess: boolean;
  output: unknown;
  cloudApiBaseUrl: string | undefined;
  getCloudAccessToken: (() => string) | undefined;
  log: LogFn;
}): Promise<PlanningTodosSubmitResult> {
  const { sessionId, runId, resultSuccess, output, cloudApiBaseUrl, getCloudAccessToken, log } = params;
  const buffered = runId ? getPlanningSessionTurnOutput(runId) : '';
  const outputFromResult = typeof output === 'string' ? output : '';
  const outputStr = buffered.trim() !== '' ? buffered : outputFromResult;
  if (!sessionId || !runId || !resultSuccess || outputStr.trim() === '') {
    return { submitted: false, suppressOutput: false };
  }
  if (!cloudApiBaseUrl || !getCloudAccessToken) {
    return { submitted: false, suppressOutput: false };
  }

  const items = parsePlanningTodoAgentJson(outputStr);
  if (items.length === 0) {
    return { submitted: false, suppressOutput: false };
  }

  const result = await submitPlanningTodosForTurn({
    sessionId,
    turnId: runId,
    items,
    cloudApiBaseUrl,
    getCloudAccessToken,
  });
  if (!result.ok) {
    log(`[Agent] Planning todo submit failed: ${result.error}`);
    return { submitted: false, suppressOutput: false };
  }

  if (runId) consumePlanningSessionTurnOutput(runId);

  log(`[Agent] Planning session: stored ${items.length} todo(s) via internal API`);
  return { submitted: true, suppressOutput: true };
}
